const dateFormatterWithDots = (date: string) => {

  if(!date) return "";

  const prepDate = new Date(date);

  return prepDate.toLocaleDateString('pl-PL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '.');
} 

  export default dateFormatterWithDots;